<div class="no-data">
    <img src="../../assets/img/sch-new-logo.png"/>
    <p>Something went wrong</p>
    <ion-button (click)="retry()">
        RETRY
    </ion-button>
</div>